import { render, staticRenderFns } from "./literatureForm.vue?vue&type=template&id=7bb48440&scoped=true&"
import script from "./literatureForm.vue?vue&type=script&lang=js&"
export * from "./literatureForm.vue?vue&type=script&lang=js&"
import style0 from "./literatureForm.vue?vue&type=style&index=0&id=7bb48440&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb48440",
  null
  
)

export default component.exports